import { View } from "binder"
import { ReportFileSelector, ReportSelectonPopupViewModel } from "./reportSelectonPopup-viewModel"

export class ReportSelectonPopupView extends View<ReportSelectonPopupViewModel>{
    GetViewUniqueId(): string {
        return "V-342D5B3B-81E1-47EE-B3B9-866918F524B1"
    }
    loadHtml(): string {
        let element = require('./reportSelectonPopup.html').default;
        let style = require('./reportSelectonPopup.less');
        return element;
    }
    constructor() {
       super();
    }

    public set selector(v: ReportFileSelector) { this._selector = v; } public get selector(): ReportFileSelector { return this._selector;} private _selector: ReportFileSelector;
    confirm(){
        this.dataContext.confirm();
    }
    back(){
        this.dataContext.back();
    }
}
